import React, { FC, ReactNode } from 'react';
import cls from 'classnames';

import styles from './index.module.sass';

interface LinkProps {
  children?: ReactNode;
  className?: string;
  href: string;
}

const Link: FC<LinkProps> = ({ children, className, href }) => (
  <a className={cls( styles.link, className )} href={href}>
    {children}
  </a>
);

export default Link;
